export const featuredResume = [{
        id    : 1,
        title : "JavaScript Modern web",
        img   : "assets/js.jpg",
        url   : "https://badsha1996.github.io/Responsive_web/",
    },
    {
        id    : 2,
        title : "Visualizer",
        img   : "assets/sort.jpg",
        url   : "https://badsha1996.github.io/Sorting_visualizer/",
    },
 ];
export const webResume = [{
        id    : 1,
        title : "JavaScript Modern web",
        img   : "assets/js.jpg",
        url   : "https://badsha1996.github.io/Responsive_web/",
    },
    {
        id    : 2,
        title : "Django website",
        img   : "https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fliwaiwai.com%2Fwp-content%2Fuploads%2F2019%2F05%2Fdjango-python.jpg&f=1&nofb=1",
        url   : "https://github.com/Badsha1996/Article-Website",
    },
    {
        id    : 3,
        title : "React Chatbot",
        img   : "https://cdn.dribbble.com/users/3226680/screenshots/10443745/media/e2050811d93aedb37737824f76e4d7aa.png?compress=1&resize=800x600",
        url   : "https://github.com/Badsha1996",
    },
    {
        id    : 4,
        title : "Visualizer",
        img   : "assets/sort.jpg",
        url   : "https://github.com/Badsha1996/Sorting_visualizer",
    },
];
export const mlResume = [{
        id    : 1,
        title : "AI Painting Software",
        img   : "https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Ffarmingtonlibraries.librarymarket.com%2Fsites%2Fdefault%2Ffiles%2F2020-12%2FVirtual%2520Paint%2520Along%2520(1).png&f=1&nofb=1",
        url   : "https://github.com/Badsha1996/virtual_painter",
    },
    {
        id    : 2,
        title : "Invisible Clothes",
        img   : "https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fcdn141.picsart.com%2F259469934017202.jpg&f=1&nofb=1",
        url   : "https://github.com/Badsha1996/Invisible_man",
    },
    {
        id    : 3,
        title : "Chatbot with voice",
        img   : "https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fherobot.app%2Fwp-content%2Fuploads%2F2020%2F10%2F339.jpg&f=1&nofb=1",
        url   : "https://github.com/Badsha1996/ChatBot-Noni-version-1.0",
    },
];
export const certificateResume = [{
        id    : 1,
        title : "Python",
        img   : "assets/python.jpg",
        url   : "https://drive.google.com/drive/folders/15cMp48Cd8VkPbGjZvzelGkqX6mb15jrh?usp=sharing",
    },
    {
        id    : 2,
        title : "Data Science",
        img   : "assets/ds.jpg",
        url   : "https://drive.google.com/drive/folders/15cMp48Cd8VkPbGjZvzelGkqX6mb15jrh?usp=sharing",
    },
    {
        id    : 3,
        title : "JavaScript",
        img   : "assets/JS.png",
        url   : "https://drive.google.com/drive/folders/15cMp48Cd8VkPbGjZvzelGkqX6mb15jrh?usp=sharing",
    },
    {
        id    : 4,
        title : "Problem Solving",
        img   : "assets/PS.png",
        url   : "https://drive.google.com/drive/folders/15cMp48Cd8VkPbGjZvzelGkqX6mb15jrh?usp=sharing",
    },
    {
        id    : 5,
        title : "Internship Selection",
        img   : "assets/internship.jpg",
        url   : "https://drive.google.com/drive/folders/15cMp48Cd8VkPbGjZvzelGkqX6mb15jrh?usp=sharing",
    },
    {
        id    : 6,
        title : "SQL",
        img   : "assets/SC.png",
        url   : "https://drive.google.com/drive/folders/15cMp48Cd8VkPbGjZvzelGkqX6mb15jrh?usp=sharing",
    },
    {
        id    : 7,
        title : "Python fundamentals",
        img   : "assets/PC.png",
        url   : "https://drive.google.com/drive/folders/15cMp48Cd8VkPbGjZvzelGkqX6mb15jrh?usp=sharing",
    },
    {
        id    : 8,
        title : "SAP Abap",
        img   : "assets/s.jpg",
        url   : "https://drive.google.com/drive/folders/15cMp48Cd8VkPbGjZvzelGkqX6mb15jrh?usp=sharing",
    },
];
export const rankResume = [
    {
        id    : 1,
        title : "5 Star on HackerRank",
        img   : "assets/hackerrank.jpg",
        url   : "https://www.hackerrank.com/badshalaskar725?hr_r=1",
    }, 
    {
        id    : 2,
        title : "3 Star on CodeChef",
        img   : "assets/codechef.jpg",
        url   : "https://www.codechef.com/users/badsha123",
    },
    {
        id    : 3,
        title : "GFG Score 300+  ",
        img   : "assets/gfg.jpg",
        url   : "https://auth.geeksforgeeks.org/user/badshalaskar/practice/",
    },
    {
        id    : 4,
        title : "ESD Project Captain ",
        img   : "https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fwallup.net%2Fwp-content%2Fuploads%2F2017%2F11%2F22%2F308555-programming.jpg&f=1&nofb=1",
        url   : "",
    },
];